import React from 'react'
import { TikTokLogoProps as ArrowDownIconProps } from './ArrowDownIconProps'

const ArrowDownIcon: React.FC<ArrowDownIconProps> = ({ className }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.785"
      height="12.014"
      viewBox="0 0 19.785 12.014"
      className={className}
    >
      <path
        data-name="Path 640"
        d="M8985.779,3371l-9.453-9.454a1.5,1.5,0,1,1,2.121-2.121l7.332,7.332,7.332-7.332a1.5,1.5,0,1,1,2.121,2.121Z"
        transform="translate(-8975.887 -3358.985)"
        fill="#fff"
      />
    </svg>
  )
}

export default ArrowDownIcon
